import React, { useEffect } from "react";

import LoaderComponent from "./LoaderComponent";
import { startLoader, stopLoader } from "./loaderUtils";

/** Inside the mobile app the native loader covers the screen instead of Sandbox's spinner. */
export const NativeRouteLoader = ({ className }) => {
  useEffect(() => {
    startLoader();
    return () => {
      stopLoader();
    };
  }, []);

  return <div className={className}></div>;
};

/**
 * What a route shows while its code loads: the native loader in the app,
 * Sandbox's spinner on the web.
 * @param {{ className?: string }} props - sizes the placeholder
 */
const RouteFallback = ({ className }) =>
  window.ReactNativeWebView ? (
    <NativeRouteLoader className={className} />
  ) : (
    <div className={className}>
      <LoaderComponent />
    </div>
  );

export default RouteFallback;
